<template>
  <div class="kye-dept-tree" ref="scrollBar">
    <el-scrollbar
      v-if="authTree[0]"
      ref="elScrollbar"
      view-class="kye-dept-tree__list"
      wrap-class="kye-dept-tree__wrap">
      <KyeOrgTree
        ref="tree"
        :accordion="accordion"
        highlight-current
        node-key="id"
        expand-on-click-node
        :data="authTree"
        :props="{label: 'name', children: 'children'}"
        :filter-node-method="filterNode"
        :defaultExpandedKeys="defaultExpandedKeys"
        :defaultExpandAll="defaultExpandAll"
        @node-click="nodeClick">
      </KyeOrgTree>
    </el-scrollbar>
    <div v-if="init && !load" class="kye-dept-tree__nodata">
      <img class="kye-dept-tree__nodata-img" :src="NoAuthImg"/>
      <p>无组织查看权限，<span class="kye-dept-tree__nodata-text">可通过关键字查询</span></p>
    </div>
  </div>
</template>

<script>
  import KyeOrgTree from 'public/components/kye-tree'
  import NoAuthImg from 'public/assets/images/no-auth.png'

  export default {
    components: { KyeOrgTree },
    props: {
      load: { // 是否正在加载
        type: Boolean,
        default: false
      },
      init: {
        type: Boolean,
        default: false
      },
      authTree: {
        type: Array,
        default: () => ([])
      },
      accordion: {
        type: Boolean,
        default: true
      },
      defaultExpandedKeys: {
        type: Array,
        default: () => ([])
      },
      defaultExpandAll: Boolean,
    },
    data () {
      return {
        NoAuthImg: NoAuthImg
      }
    },
    mounted () {
      this.$bus.$on('GLOBAL_RESIZE', this.handleResize)
    },
    beforeDestroy () {
      this.$bus.$off('GLOBAL_RESIZE', this.handleResize)
    },
    methods: {
      handleResize () {
        this.$refs.elScrollbar && this.$refs.elScrollbar.update()
      },
      filterTree (id) {
        this.id = id
        this.$refs.tree.filter(id)
      },
      filterNode (val, data) {
        let flag = val === data.id
        if (flag) {
          this.setCheckedDept(this.id)
        }
        return flag
      },
      nodeClick (data) {
        this.$emit('nodeClick', data)
      },
      setCheckedDept (id) {
        // 展开指定的部门，并且滚动到该元素所在位置
        this.$nextTick(_ => {
          this.$refs.tree.setCurrentKey(id)
          this.$nextTick(_ => {
            // el滚动条容器
            const elScrollbar = this.$refs.elScrollbar.wrap
            let dom = elScrollbar.querySelector('.el-tree-node.is-expanded.is-current')
            if (dom) {
              let top = dom.offsetTop - 26
              elScrollbar.scrollTo({ top, behavior: 'smooth' })
            }
          })
        })
      },
      getCurrentNode () {
        return this.$refs.tree && this.$refs.tree.getCurrentNode()
      }
    }
  }
</script>

<style lang="less">
  .kye-dept-tree {
    height: 100%;
    overflow: hidden;
    .el-scrollbar {
      height: 100%;
    }
    &__wrap {
      height: 100%;
      overflow: auto;
      .el-scrollbar__bar.is-horizontal {
        display: none;
      }
    }
    &__nodata {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #B0B3BF;
      margin-top: 80px;
      &-img {
        // width: 140px;
        height: 200px;
      }
      &-text {
        color: #1B2240;
      }
      p {
        margin-top: 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-dept/dept-tree.vue